import { Link } from "react-router-dom";

const Tab14 = () => {
window.location.assign("https://www.linkedin.com/company/btcoley/")
    
}

export default Tab14;